import axios from 'axios';

export default {
    data() {
        return {
            cookieName: "experiment",
            allowedEvents: [
                'search_page_view', // Homepage + Craft location pages
                'vehicle_select_page_view', // Vehicles list
                'options_page_view', // Options page
                'driver_details_page_view', // Driver details page
                'payment_details_page_view', // Payment details page
                'thank_you_page_view', // Thank you page
            ],
            unallocatedExperimentSlug: 'unallocated'
        }
    },

    methods: {
        getCookie() {
            const regex = new RegExp('(^|;)\\s*' + this.cookieName + '\\s*=\\s*([^;]+)');
            var match = document.cookie.match(regex);

            if (match) {
                const ab_cookie = JSON.parse(match.pop());

                return ab_cookie;
            }

            return null;
        },

        getSession(event_name) {
            if (!this.allowedEvents.includes(event_name)) {
                return null;
            }

            return window.sessionStorage.getItem(event_name);
        },

        getApiAxiosCall() {
            let coreEndpoint = window.greenmotion ? window.greenmotion.coreEndpoint : '';

            return axios.create({
                baseURL: API_BASE_URL || coreEndpoint,
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
            });
        },

        async checkExperiment(experiment_slug) {
            const ab_cookie = this.getCookie();

            if (ab_cookie) {
                return {
                    slug: ab_cookie.experiment_slug,
                    complete: ab_cookie.complete_experiments.includes(experiment_slug)
                } ?? null;
            }

            // If no cookie, check API for experiment
            // --------------------------------------------------
            const experiment_info = await this.getApiAxiosCall()
                .get(`ab/${experiment_slug}/check-experiment`, { params: {} })
                .then((response) => response.data);

            // Only save the cookie if the user is in a experiment
            if (experiment_info?.experiment_slug) {
                // Set Cookie (expire in 10 minutes)
                const mins = 10;
                var date = new Date();
                date.setTime(date.getTime() + (mins * 60 * 1000));
                var expires = "; expires=" + date.toUTCString();

                // Cookie Domain
                var domain = new URL(window.location.href).hostname;
                const parts = domain.split('.');
                domain = (parts.length > 2) ? parts.slice(1).join('.') : domain;
                domain = "; domain=." + domain;

                document.cookie = this.cookieName + "=" + JSON.stringify(experiment_info) + domain + expires + "; path=/";
            }

            return {
                slug: experiment_info.experiment_slug,
                complete: experiment_info.complete_experiments.includes(experiment_slug)
            } ?? null;
        },

        async addVisit(event_name, event_data) {
            const session_quote_id = this.getSession(event_name);

            if(session_quote_id) {
                if(session_quote_id === event_data?.quote_id){
                    return;
                }
            }

            if (event_name === 'thank_you_page_view') {
                const payment_quote_id = this.getSession('payment_details_page_view')

                if (!payment_quote_id) {
                    return;
                }
            }

            window.sessionStorage.setItem(event_name, event_data?.quote_id);

            let data = {
                page_title: document.title,
                page_location: window.location.href,
                page_path: window.location.pathname,
                experiment_slug: this.getCookie()?.experiment_slug ?? this.unallocatedExperimentSlug,
                experiment_stage: event_name,
                ...event_data
            }

            // Send the visits if the event is allowed
            await this.getApiAxiosCall()
                .post(`ab/add-visit`, {
                    "event_name": event_name,
                    "data": data
                })

            // If for some reason the analytics event fails, log the error
            try {
                this.notifyGoogleAnalytics(event_name, data)
            } catch (error) {
                this.getApiAxiosCall()
                    .post(`ab/log-event-error`, {
                        event_name: event_name,
                        data: data,
                        message: 'gtag send failure.',
                        error: error.message
                    })
            }
        },

        addVisitAndEventForQuoteJourney(event_name, event_data = null) {
            const session_quote_id = this.getSession(event_name);

            if(session_quote_id) {
                if(session_quote_id === event_data?.quote_id){
                    return;
                }
            }

            window.sessionStorage.setItem(event_name, event_data?.quote_id);

            // Send the visits if the event is allowed
            return this.getApiAxiosCall()
                .post(`ab/add-visit-and-event`, {
                    "event_name": event_name,
                    "event_data": event_data
                })
        },

        async notifyGoogleAnalytics(event_name, event_data) {
            let debug_mode_enabled = window.greenmotion && typeof window.greenmotion.googleDebugModeEnabled !== 'undefined' ? window.greenmotion.googleDebugModeEnabled : false;
            const http = this.getApiAxiosCall()

            let google_event_data = event_data

            // Debug mode should be handle by a variable, to avoid activating the debug mode in production
            if (debug_mode_enabled) {
                google_event_data = {
                    debug_mode: true,
                    ...google_event_data
                }
            }

            gtag("event", event_name, google_event_data);
        }
    }
}
